module.exports = __webpack_public_path__ + "img/made-in-france.57c1e273.png";